export class Policies {
  constructor(
    public admin = false,
    public mod = false,
    public vip = false,
    public sub = false,
    public others = false
  ) {
  }
}
